/**
 * This isn't actually used, but exists as a fallback for items that need unicode characters in URLS. 
 * As of right now, the Colleciton Highlights are rendered by src/pages/{NodeCollectionHighlight.path__alias}.js
 */

 import * as React from 'react'
 
 import { GatsbyImage } from "gatsby-plugin-image"
 import '../uglib_styles/newsItem.css'
 
 import { Helmet } from 'react-helmet'
 import Seo from '../uglib_components/seo'
 import Breadcrumbs from '../uglib_components/breadcrumbs'
 import Layout from '../uglib_components/layout'
 import {process_inline_images, get_labelled_field, get_optional_field} from 'src/uglib_utils/utils'

const NewsPage = ({pageContext}) => {
	const data = pageContext.node;
	const files = pageContext.files;

	const keywords = data.relationships.field_keywords.map(function(element) {return element.name})
	const news_story_image = data.relationships.field_news_story_image.localFile.childImageSharp.gatsbyImageData;
	const body = data.body.processed;

	/**
	 * This replaces inline-images uploaded through CKEditor in the body field with Gatsby Images. 
	 * See: https://www.andrewl.net/article/gatsby-drupal-inline-images
	 */
	const processed_body = process_inline_images(body, files);
	
	const title = data.title;

	let news_hero_image = null;
	
	if (data.relationships.field_media_image !== null) {
		news_hero_image = data.relationships.field_media_image.relationships.field_media_image.localFile.childImageSharp.gatsbyImageData;
	}

	const breadcrumbs = [
		{ 
			url: "/news",
			title: "News",
		}
	]

	let header = <></>;
	if (news_hero_image !== null) {
		header = <>
		<Helmet bodyAttributes={{
			class: 'news'
		}}
		/>
		
		<Helmet><script defer type="text/javascript" src="/assets/uog-media-player.js"></script></Helmet>
		<Seo title={title} keywords={keywords} />

		{ /**** Header and Title ****/ }
		<div id="rotator">
			<GatsbyImage className="hero-image"	image={news_hero_image} alt={data.relationships.field_media_image.field_media_image.alt} placeholder="blurred" />			
			<div className="container ft-container">
				<h1 className="fancy-title">{title}</h1>
			</div>
		</div>

		<Breadcrumbs links={breadcrumbs} nodeTitle={title} />
	</>;
	}
	else {
		header = <>
			<Helmet bodyAttributes={{
				class: 'news'
			}}
			/>
			<div className="no-thumb" id="rotator">
				<div className="container ft-container">
					<h1 className="fancy-title">{title}</h1>
				</div>
			</div>

			<Helmet><script defer type="text/javascript" src="/assets/uog-media-player.js"></script></Helmet>
			<Seo title={title} keywords={keywords} />

			<Breadcrumbs links={breadcrumbs} nodeTitle={title} />
		</>;
	}

	let attribution = <></>;
	if (data.field_attribution !== null) {
		attribution = <span className="attribution" dangerouslySetInnerHTML={{__html: data.field_attribution.processed}} />
	}

	let news_image_alt = '';
	if (data.field_news_story_image !== null && data.field_news_story_image.alt !== null) {
		news_image_alt = data.field_news_story_image.alt;
	}

    const license = get_labelled_field(get_optional_field(data, 'relationships.field_content_license.description.processed'), <h2>License</h2>);

    return (
      <Layout header={header} title={title} keywords={keywords} date={data.changed}>

			{ /**** News story image ****/ }
			<div>
				<GatsbyImage className="news-image ug-lib-image" image={news_story_image} alt={news_image_alt} placeholder="blurred" />

				{ attribution }

				{ /**** Legacy body field ****/}
				{processed_body}

				{ license }
			</div>
      </Layout>
    )
}

export default NewsPage